import React from "react";
import { Icon, Image, Grid, Divider } from 'semantic-ui-react'
import Images from "../../../../config/images"
import HeaderLabel from "./HeaderLabel"
import HeaderContent from "./HeaderContent";
import HeaderFooter from "./HeaderStatusIndicators"
const Header = ({headerData={}, headerContentRenderItem, headerFooterRenderItem, buttonMapper}) => {
  return (
    <Grid>
      <Grid.Row className="header-top" columns={2} >
        <Grid.Column>
          <HeaderLabel logo={Images.OCEAN} label="Reconcilation form (US)" />
        </Grid.Column>
        <Grid.Column textAlign="right" stackable>
          {buttonMapper}
        </Grid.Column>
      </Grid.Row>
      <Grid.Row className="header-content" columns={5}>
        <HeaderContent data={headerData} renderItem={headerContentRenderItem} />
      </Grid.Row>
      <Grid.Row className="header-footer">
        <HeaderFooter data={headerData} renderItem={headerFooterRenderItem} />
      </Grid.Row>
    </Grid>
  )
}
 
export default Header;